<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="商品名称">
        <el-input v-model="queryForm.productName" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="商品分类">
        <el-select
          v-model="queryForm.categoryId"
          placeholder="请选择商品分类"
          clearable
          size="small"
          style="width: 200px"
        >
          <el-option
            v-for="item in categoryList"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getProductList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetQueryFrom"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            plain
            size="small"
            icon="el-icon-plus"
            @click="deleteProduct(null)"
          >批量删除</el-button>
          <el-button
            type="primary"
            plain
            size="small"
            icon="el-icon-upload2"
            @click="triggerImport"
          >批量导入</el-button>
          <el-button
            type="primary"
            plain
            size="small"
            icon="el-icon-download"
            @click="importTemplate"
          >导出模板</el-button>
        </div>

        <div class="icon-group">
          <el-upload
            ref="importUpload"
            style="display: none;"
            action="#"
            :http-request="upload"
            :show-file-list="false"
            accept=".xls,.xlsx"
          >
          </el-upload>
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshProductList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="productList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="10%"
        > </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="productName"
          label="商品名称"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="productPic"
          label="商品图片"
          min-width="15%"
        >
          <template slot-scope="scope">
            <div style="display: flex; justify-content: center; align-items: center;">
              <div v-if="getFirstProductPic(scope.row.productPic)" style="display: inline-block;">
                <!-- 商品图片是逗号分隔的字符串，取第一张 -->
                <el-image
                    @click='updateSrcList(getFirstProductPic(scope.row.productPic))'
                    style="width: 50px; height: 50px"
                    :src="getFirstProductPic(scope.row.productPic)"
                    :preview-src-list="getProductPicList(scope.row.productPic)"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                    <div>暂无图片</div>
                  </div>
                </el-image>
              </div>
              <div v-else class="no-image-placeholder">
                <i class="el-icon-picture-outline"></i>
                <div>暂无图片</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="shopPrice"
          label="价格"
          min-width="15%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="stockSize"
          label="库存"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          min-width="20%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkProduct(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editProduct(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteProduct(scop.row.id)">
                <Icon
                  size="16"
                  style="color: red"
                >
                  <Delete24Regular />
                </Icon>
                <span
                  class="operation-label"
                  style="color: red"
                >删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 查看/修改信息 -->
      <el-dialog
        :title="productStates[productState]"
        :visible.sync="showDialog"
        width="80%"
        @close="closeDialog"
        :close-on-click-modal="false"
      >
        <div v-loading="loading">
          <el-form
            :model="product"
            ref="productForm"
            :rules="rules"
            label-width="120px"
            size="small"
          >
            <!-- 商品图片 -->
            <el-form-item
              label="商品图片"
              prop="productPics"
            >
              <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                <div
                  v-for="(pic, index) in product.productPics"
                  :key="index"
                  style="position: relative; width: 100px; height: 100px; border: 1px solid #ddd; border-radius: 4px; overflow: hidden;"
                >
                  <img
                    :src="pic"
                    style="width: 100%; height: 100%; object-fit: cover;"
                  />
                  <div
                    v-if="index === 0"
                    style="position: absolute; top: 0; left: 0; background: rgba(0,0,0,0.6); color: white; padding: 2px 5px; font-size: 12px;"
                  >主图</div>
                  <i
                    v-if="productState != 'check'"
                    class="el-icon-close"
                    style="position: absolute; top: 0; right: 0; background: rgba(255,0,0,0.8); color: white; cursor: pointer; padding: 2px 5px;"
                    @click="removeProductPic(index)"
                  ></i>
                </div>
                <el-upload
                  v-if="productState != 'check'"
                  action=""
                  :http-request="uploadProductPic"
                  :show-file-list="false"
                  list-type="picture-card"
                  style="display: inline-block;"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </el-form-item>

            <!-- 商品名称 -->
            <el-form-item
              label="商品名称"
              prop="productName"
            >
              <el-input
                size="small"
                style="width: 300px"
                v-model="product.productName"
                :disabled="productState == 'check'"
                placeholder="请输入商品名称"
              ></el-input>
            </el-form-item>

            <!-- 售价 -->
            <el-form-item
              label="售价"
              prop="shopPrice"
            >
              <el-input
                size="small"
                style="width: 300px"
                v-model="product.shopPrice"
                :disabled="productState == 'check'"
                placeholder="请输入售价"
              ></el-input>
            </el-form-item>

            <!-- 进货价格 -->
            <el-form-item
              label="进货价格"
              prop="supplyPrice"
            >
              <el-input
                size="small"
                style="width: 300px"
                v-model="product.supplyPrice"
                :disabled="productState == 'check'"
                placeholder="请输入进货价格"
              ></el-input>
            </el-form-item>

            <!-- 商品分类 -->
            <el-form-item
              label="商品分类"
              prop="categoryId"
            >
              <el-select
                size="small"
                style="width: 300px"
                v-model="product.categoryId"
                :disabled="productState == 'check'"
                placeholder="请选择商品分类"
                clearable
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- 排序 -->
            <el-form-item
              label="排序"
              prop="sort"
            >
              <el-input
                size="small"
                style="width: 300px"
                v-model="product.sort"
                :disabled="productState == 'check'"
                placeholder="请输入排序"
              ></el-input>
            </el-form-item>

            <!-- 库存 -->
            <el-form-item
              label="库存"
              prop="stockSize"
            >
              <el-input
                size="small"
                style="width: 300px"
                v-model="product.stockSize"
                :disabled="productState == 'check'"
                placeholder="请输入库存"
              ></el-input>
            </el-form-item>

            <!-- 起批 -->
            <el-form-item
              label="起批"
              prop="buyMinLimit"
            >
              <el-input
                size="small"
                style="width: 300px"
                v-model="product.buyMinLimit"
                :disabled="productState == 'check'"
                placeholder="请输入起批数量"
              ></el-input>
            </el-form-item>

            <!-- 限购 -->
            <el-form-item
              label="限购"
              prop="buyLimit"
            >
              <el-input
                size="small"
                style="width: 300px"
                v-model="product.buyLimit"
                :disabled="productState == 'check'"
                placeholder="请输入限购数量"
              ></el-input>
            </el-form-item>

            <!-- 商品详情内容 -->
            <el-form-item
              label="商品详情内容"
              prop="productContent"
            >
              <el-input
                type="textarea"
                :rows="5"
                style="width: 600px"
                v-model="product.productContent"
                :disabled="productState == 'check'"
                placeholder="请输入商品详细描述"
              ></el-input>
            </el-form-item>

            <!-- 商品详情图片 -->
            <el-form-item
              label="商品详情图片"
              prop="detailPics"
            >
              <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                <div
                  v-for="(pic, index) in product.detailPics"
                  :key="index"
                  style="position: relative; width: 100px; height: 100px; border: 1px solid #ddd; border-radius: 4px; overflow: hidden;"
                >
                  <img
                    :src="pic"
                    style="width: 100%; height: 100%; object-fit: cover;"
                  />
                  <i
                    v-if="productState != 'check'"
                    class="el-icon-close"
                    style="position: absolute; top: 0; right: 0; background: rgba(255,0,0,0.8); color: white; cursor: pointer; padding: 2px 5px;"
                    @click="removeDetailPic(index)"
                  ></i>
                </div>
                <el-upload
                  v-if="productState != 'check'"
                  action=""
                  :http-request="uploadDetailPic"
                  :show-file-list="false"
                  list-type="picture-card"
                  style="display: inline-block;"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="productState != 'check'"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, post, postJson, deleteFun, upload, importDate } from '@/utils/request.js';
import axios from 'axios';
import { Message } from 'element-ui';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    data() {
        return {
            queryForm: {
                productName: '',
                categoryId: ''
            },
            loading: false,
            btnLoading: false,
            showDialog: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentProductId: '',
            productState: 'edit',
            productStates: {
                check: '查看商品',
                edit: '修改商品'
            },
            multipleSelection: [],
            productList: [],
            categoryList: [], // 商品分类列表
            product: {
                productName: '',
                shopPrice: '',
                supplyPrice: '',
                categoryId: '',
                sort: '',
                stockSize: '',
                buyMinLimit: '',
                buyLimit: '',
                productPics: [], // 商品图片数组（第一张为主图）
                productContent: '',
                detailPics: [] // 商品详情图片数组
            },
            rules: {
                productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                shopPrice: [{ required: true, message: '售价不能为空', trigger: 'blur' }],
                supplyPrice: [{ required: true, message: '进货价格不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '商品分类不能为空', trigger: 'change' }]
            },
            srcList:[''],//大图预览
        };
    },
    created() {
        this.getProductList();
        this.getCategoryList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetProductList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.productList = [];
        },
        resetDialog() {
            this.productState = 'edit';
            this.showDialog = false;
            this.product = {
                productName: '',
                shopPrice: '',
                supplyPrice: '',
                categoryId: '',
                sort: '',
                stockSize: '',
                buyMinLimit: '',
                buyLimit: '',
                productPics: [],
                productContent: '',
                detailPics: []
            };
        },
        closeDialog() {
            this.resetDialog();
            if (this.$refs.productForm) {
                this.$refs.productForm.resetFields();
            }
        },
        submitForm() {
            this.$refs.productForm.validate((valid) => {
                if (valid) {
                    // 准备提交数据，按照接口要求的字段格式
                    const submitData = {
                        id: this.currentProductId,
                        productName: this.product.productName,
                        shopPrice: this.product.shopPrice,
                        supplyPrice: this.product.supplyPrice,
                        categoryId: this.product.categoryId,
                        sort: this.product.sort || 1,
                        stockSize: this.product.stockSize,
                        buyMinLimit: this.product.buyMinLimit,
                        buyLimit: this.product.buyLimit,
                        productContent: this.product.productContent || '',
                        productPic: Array.isArray(this.product.productPics) 
                            ? this.product.productPics.join(',') 
                            : (this.product.productPics || ''),
                        productContentPic: Array.isArray(this.product.detailPics) 
                            ? this.product.detailPics.join(',') 
                            : (this.product.detailPics || '')
                    };
                    
                    postJson(`/ex-shop/ex/shop/product/updateProduct`, submitData).then((res) => {
                        if (res.code == 200 || res.success) {
                            this.$message({
                                message: res.message || res.msg || '修改成功',
                                type: 'success',
                                duration: 2000
                            });
                            this.resetProductList();
                            this.closeDialog();
                            this.getProductList();
                        } else {
                            this.$message({
                                message: res.message || res.msg || '修改失败',
                                type: 'error',
                                duration: 2000
                            });
                        }
                    }).catch((error) => {
                        this.$message({
                            message: '修改失败',
                            type: 'error',
                            duration: 2000
                        });
                        console.error('修改失败:', error);
                    });
                }
            });
        },

        updateSrcList(src){
            this.srcList[0] = src
        },
        // 获取第一张商品图片
        getFirstProductPic(productPic) {
            if (!productPic) return '';
            if (typeof productPic === 'string') {
                const pics = productPic.split(',').filter(url => url.trim());
                return pics.length > 0 ? pics[0] : '';
            }
            return productPic;
        },
        // 获取所有商品图片列表（用于预览）
        getProductPicList(productPic) {
            if (!productPic) return [];
            if (typeof productPic === 'string') {
                return productPic.split(',').filter(url => url.trim());
            }
            return Array.isArray(productPic) ? productPic : [productPic];
        },

        checkProduct(productId) {
            this.currentProductId = productId;
            this.getProductById();
            this.showDialog = true;
            this.productState = 'check';
        },
        editProduct(productId) {
            if (productId) {
                this.currentProductId = productId;
                this.getProductById();
            } else {
                this.product = { ...this.product, ...this.multipleSelection[0] };
            }
            this.showDialog = true;
            this.productState = 'edit';
        },
        deleteProduct(productId) {
            // 确定要删除的商品ID列表
            console.log(this.multipleSelection.map((product) => product.id),'this.multipleSelection');
            
            let deleteIds = [];
            if (productId) {
                deleteIds = [productId];
            } else {
              if(this.multipleSelection.length > 0){
                deleteIds = this.multipleSelection.map((product) => product.id);
              }else{
                deleteIds = [];
              }
            }   
            
            if (deleteIds.length === 0) {
                this.$message({
                    message: '请选择要删除的商品',
                    type: 'warning',
                    duration: 2000
                });
                return;
            }
            console.log(deleteIds,'deleteIds');
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    // 批量删除：循环调用删除接口
                    // const deletePromises = deleteIds.map(id => {
                    //     return postJson(`/ex-shop/ex/shop/product/deleteProducts`, { id });
                    // });
                    axios({
                        method: 'post',
                        url: '/ex-shop/ex/shop/product/deleteProducts',
                        data: deleteIds
                    }).then((res) => {
                        if (res.data.code == 200 || res.data.success) {
                          this.$message({
                                message: '删除成功',
                                type: 'success',
                                duration: 2000
                            });
                            // 删除成功后刷新列表
                            this.resetProductList();
                            this.getProductList();
                        }else{
                          this.$message({
                                message: res.data.message || res.data.msg || '删除失败',
                                type: 'error',
                                duration: 2000
                            });
                        }
                    }).catch((err) => {
                        this.$message({
                            message: err.response?.data?.msg || '删除失败',
                            type: 'error',
                            duration: 2000
                        });
                    });
                    
                    // Promise.all(deletePromises).then((results) => {
                    //     // 检查所有删除操作是否成功
                    //     const allSuccess = results.every(res => res.code == 200 || res.success);
                    //     if (allSuccess) {
                    //         this.$message({
                    //             message: '删除成功',
                    //             type: 'success',
                    //             duration: 2000
                    //         });
                    //         // 删除成功后刷新列表
                    //         this.resetProductList();
                    //         this.getProductList();
                    //     } else {
                    //         const failedCount = results.filter(res => !(res.code == 200 || res.success)).length;
                    //         this.$message({
                    //             message: `删除失败，${failedCount}个商品删除失败`,
                    //             type: 'error',
                    //             duration: 2000
                    //         });
                    //     }
                    // }).catch((error) => {
                    //     this.$message({
                    //         message: '删除失败',
                    //         type: 'error',
                    //         duration: 2000
                    //     });
                    //     console.error('删除失败:', error);
                    // });
                })
                .catch(() => {});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            axios({
                method: 'get',
                url: 'https://tyapi.jinciteng.cn/ex-shop/supply_excel_template.xlsx',
                // url:'https://tianyimgrtest.tianelive.com/ex-shop/supply_excel_template.xlsx',
                responseType: 'blob'
            })
            .then((res) => {
                this.btnLoading = false;
                if (res.data.type || res.data instanceof Blob) {
                    // 文件下载
                    const blob = new Blob([res.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    let link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', '导入模板.xlsx');
                    link.click();
                    link = null;
                    this.$message({
                        message: '下载成功',
                        type: 'success',
                        duration: 2000
                    });
                } else {
                    // 返回json
                    this.$message.warning('下载失败');
                }
            })
            .catch((err) => {
                this.btnLoading = false;
                this.$message.error('下载失败');
            });
        },
        /**
         * 触发导入文件选择
         */
        triggerImport() {
            this.$refs.importUpload.$el.querySelector('input[type="file"]').click();
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            importDate(`/ex-shop/ex/shop/order/file/uploadExcel`, formData).then(() => {
                this.refreshProductList();
            });
        },
        refreshProductList() {
            this.resetProductList();
            this.getProductList();
        },
        getProductList() {
            this.loading = true;
            get(`/ex-shop/ex/shop/product/getProducts`, { 
                current: this.currentPage, 
                size: this.pageSize,
                productName: this.queryForm.productName || '',
                categoryId: this.queryForm.categoryId || ''
            }).then((res) => {
                this.loading = false;
                // 根据实际接口返回的数据结构调整
                if (res.code == 200) {
                    // 如果接口返回的数据结构不同，需要根据实际情况调整
                    this.productList =  res.data?.list || [];
                    this.totalNum = res.data?.total || 0;
                } else {
                    this.$message({
                        message: res.msg || res.message || '获取列表失败',
                        type: 'error',
                        duration: 2000
                    });
                }
            }).catch((error) => {
                this.loading = false;
                this.$message({
                    message: '获取列表失败',
                    type: 'error',
                    duration: 2000
                });
                console.error('获取列表失败:', error);
            });
        },
        resetQueryFrom() {
            this.queryForm.productName = '';
            this.queryForm.categoryId = '';
            this.getProductList();
        },
        getProductById() {
            this.loading = true;
            get(`/ex-shop/ex/shop/product/getProductDetail`, { id: this.currentProductId }).then((res) => {
                this.loading = false;
                // 根据实际接口返回的数据结构调整
                if (res.code == 200) {
                    const productData = res.data;
                    console.log('商品详情数据:', productData); // 调试用
                    
                    // 处理商品图片 - 按逗号分割字符串
                    if (productData.productPic) {
                        this.product.productPics = productData.productPic.split(',').filter(url => url.trim());
                    } else {
                        this.product.productPics = [];
                    }
                    
                    // 处理详情图片 - 按逗号分割字符串
                    if (productData.productContentPic) {
                        this.product.detailPics = productData.productContentPic.split(',').filter(url => url.trim());
                    } else {
                        this.product.detailPics = [];
                    }
                    
                    // 直接使用接口返回的字段名，保持与接口一致
                    this.product = {
                        productName: productData.productName || '',
                        shopPrice: productData.shopPrice || '',
                        supplyPrice: productData.supplyPrice || '',
                        categoryId: productData.categoryId || '',
                        sort: productData.sort || '',
                        stockSize: productData.stockSize || '',
                        buyMinLimit: productData.buyMinLimit || '',
                        buyLimit: productData.buyLimit || '',
                        productContent: productData.productContent || '',
                        productPics: this.product.productPics,
                        detailPics: this.product.detailPics
                    };
                    
                    console.log('处理后的商品数据:', this.product); // 调试用
                } else {
                    this.$message({
                        message: res.message || '获取商品信息失败',
                        type: 'error',
                        duration: 2000
                    });
                }
            }).catch((error) => {
                this.loading = false;
                this.$message({
                    message: '获取商品信息失败',
                    type: 'error',
                    duration: 2000
                });
                console.error('获取商品信息失败:', error);
            });
        },
        // 获取商品分类列表
        getCategoryList() {
            get(`/ex-shop/ex/shop/order/category/queryAllCategory`).then((res) => {
                // 根据实际接口返回的数据结构调整
                if (res.code == 200) {
                    this.categoryList = res.data || res.list || res || [];
                }
            }).catch((error) => {
                console.error('获取分类列表失败:', error);
            });
        },
        // 上传商品图片
        uploadProductPic(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
                return;
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    if (!this.product.productPics) {
                        this.product.productPics = [];
                    }
                    this.product.productPics.push(res.url);
                } else {
                    this.$message({
                        message: res.msg || '上传失败',
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        // 删除商品图片
        removeProductPic(index) {
            this.product.productPics.splice(index, 1);
        },
        // 上传详情图片
        uploadDetailPic(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
                return;
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    if (!this.product.detailPics) {
                        this.product.detailPics = [];
                    }
                    this.product.detailPics.push(res.url);
                } else {
                    this.$message({
                        message: res.msg || '上传失败',
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        // 删除详情图片
        removeDetailPic(index) {
            this.product.detailPics.splice(index, 1);
        },
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getProductList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getProductList();
        }
    }
};
</script>

<style lang="scss" scoped>

.page-content{
    height: 100%;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.no-image-placeholder {
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    color: #909399;
    font-size: 12px;
    text-align: center;
}
.no-image-placeholder i {
    font-size: 20px;
    margin-bottom: 2px;
    color: #c0c4cc;
}
.no-image-placeholder div {
    font-size: 10px;
    line-height: 1;
}
.image-slot {
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    color: #909399;
    font-size: 12px;
    text-align: center;
}
.image-slot i {
    font-size: 20px;
    margin-bottom: 2px;
    color: #c0c4cc;
}
.image-slot div {
    font-size: 10px;
    line-height: 1;
}
</style>
